/**
 * Taking back an answer on a question whose template turned on `allowDeselect`.
 *
 * A radio or dropdown can't normally be unselected, and a yes/no switch has no way back
 * to "not answered", so without this an answer picked by mistake can only be swapped
 * for another one. Both note and patient-form renderers share these so the interaction
 * is the same everywhere: pick the chosen answer again to clear it.
 */

/**
 * Whether a question offers clearing its answer: the template turned it on and the
 * question isn't required. A required question has to be answered, so the builders
 * and the API refuse both at once; this also covers data saved before that rule.
 */
export const canClearAnswer = (question: {
  required?: boolean;
  data: unknown;
}): boolean =>
  !question.required &&
  !!(question.data as { allowDeselect?: boolean | null } | null)?.allowDeselect;

/**
 * A clearable yes/no question has three states: unanswered, yes, and no. Clicking walks
 * through them in that order and back to unanswered, so "No" stays one click away from
 * "Yes" and an answer given by mistake can be taken back.
 */
export const nextToggleValue = (value: unknown): boolean | null => {
  if (value === true) return false;
  if (value === false) return null;
  return true;
};
